export default __webpack_public_path__ + "static/media/logoWithoutText.f8b82fed.png";